import { useMemo } from 'react';
import { useRoutesContext } from '../index';

import { getCountryISO2 } from 'shared/utils';

import { EMPTY_ARRAY } from 'common/constants';

export const useActiveRouteCountryCodes = () => {
  const { activeRoute } = useRoutesContext();

  const activeRouteCountryCodes = useMemo(
    () => activeRoute?.countryOnRoute.map((country) => getCountryISO2(country)) || EMPTY_ARRAY,
    [activeRoute]
  );

  return activeRouteCountryCodes;
};
